import { BaseApiClient } from './base-client'
import { companiesClient } from './companies.client'
import { authClient } from './auth.client'
import { agentsApiClient } from './agents.client'
import { agentsAdminApiClient } from './agents-admin.client'
import { knowledgeApiClient } from './knowledge.client'
import { contactResolutionApiClient } from './contact-resolution.client'
import { contactsApiClient } from './contacts.client'
import { propertyResolutionApiClient } from './property-resolution.client'
import { propertiesApiClient } from './properties.client'
import { reportingApiClient } from './reporting.client'

/**
 * Registry for managing API clients
 * Implements the Registry pattern to centralize client management
 */
class ApiClientRegistry {
  private clients: BaseApiClient[] = []

  constructor() {
    // Register all API clients
    this.register(companiesClient)
    this.register(authClient)
    this.register(agentsApiClient)
    this.register(agentsAdminApiClient)
    this.register(knowledgeApiClient)
    this.register(contactResolutionApiClient)
    this.register(contactsApiClient)
    this.register(propertyResolutionApiClient)
    this.register(propertiesApiClient)
    this.register(reportingApiClient)
  }

  /**
   * Register an API client with the registry
   * @param client - The API client to register
   */
  register(client: BaseApiClient): void {
    if (!this.clients.includes(client)) {
      this.clients.push(client)
    }
  }

  /**
   * Get the number of registered clients (useful for testing)
   * @returns The number of registered clients
   */
  getRegisteredCount(): number {
    return this.clients.length
  }
}

// Export singleton instance
export const apiClientRegistry = new ApiClientRegistry()
